import { isValidObject, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
import { DOT_SYMBOL } from '../../constants/constants';
export var validateFileInput = fileEvent => {
  var MAX_SIZE_MB = 5;
  var ALLOWED_TYPES = ['image/jpg', 'image/png', 'image/jpeg'];
  var _file = fileEvent === null || fileEvent === void 0 ? void 0 : fileEvent.files[0];
  var _fileSize = _file === null || _file === void 0 ? void 0 : _file.size;
  var _fileType = _file === null || _file === void 0 ? void 0 : _file.type;
  var isSizeValid = _fileSize <= MAX_SIZE_MB * 1024 * 1024;
  var isTypeValid = ALLOWED_TYPES.includes(_fileType);
  return {
    isSizeValid,
    isTypeValid
  };
};
export var getIsDisabledState = (disabledState, widgetInternalDisabledState) => {
  return disabledState || widgetInternalDisabledState;
};
export var getSubHeading = (addressProofValue, addressProofNumber, subHeading, idProofValue, idProofNumber) => {
  if (subHeading) {
    return subHeading;
  }
  if (idProofValue && idProofNumber) return addressProofValue + " " + DOT_SYMBOL + " " + addressProofNumber + " " + DOT_SYMBOL + " " + idProofValue + " " + DOT_SYMBOL + " " + idProofNumber;
  return addressProofValue + " " + DOT_SYMBOL + " " + addressProofNumber;
};
export var getIdentityProofStyles = () => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    calloutStyles: {
      marginBottom: spacing.SPACING_16
    },
    dropdownStyles: {
      marginBottom: spacing.SPACING_8
    },
    dropdownMenuItemStyles: {
      marginVertical: spacing.SPACING_4
    },
    inputStyles: {
      marginBottom: spacing.SPACING_2
    },
    dividerStyles: {
      marginTop: spacing.SPACING_16
    },
    checkboxStyles: {
      marginTop: spacing.SPACING_16,
      marginBottom: spacing.SPACING_24
    },
    uploadFileWidgetFront: {
      marginTop: spacing.SPACING_12,
      marginBottom: spacing.SPACING_16
    },
    typography: {
      marginTop: spacing.SPACING_4
    }
  });
};
export var extractFileData = fileInput => {
  var _a;
  var file = (_a = fileInput === null || fileInput === void 0 ? void 0 : fileInput.files) === null || _a === void 0 ? void 0 : _a[0];
  if (!file) return null;
  var filePath = fileInput === null || fileInput === void 0 ? void 0 : fileInput.value;
  var fileName = filePath.match(/[^\\]+$/)[0];
  var fileSize = (file.size / (1024 * 1024)).toFixed(2);
  var imgUrl = URL.createObjectURL(file);
  var truncatedFilename = fileName.length > 20 ? (fileName === null || fileName === void 0 ? void 0 : fileName.substring(0, 20)) + '...' : fileName;
  return {
    subTitle: truncatedFilename + " | " + fileSize + " MB",
    state: 'none',
    showDeleteIcon: true,
    imgUrl
  };
};
export var isValidIdentityProof = args => {
  var addressProofValue = args.addressProofValue,
    addressProofNumber = args.addressProofNumber,
    isChecked = args.isChecked,
    idProofValue = args.idProofValue,
    idProofNumber = args.idProofNumber,
    frontfileUpload = args.frontfileUpload,
    backfileUpload = args.backfileUpload,
    frontfileIdentityUpload = args.frontfileIdentityUpload,
    backfileIdentityUpload = args.backfileIdentityUpload;
  var baseValidation = !!addressProofValue && !!addressProofNumber && isValidObject(frontfileUpload) && isValidObject(backfileUpload);
  if (isChecked) {
    return baseValidation;
  }
  return baseValidation && !!idProofValue && !!idProofNumber && isValidObject(frontfileIdentityUpload) && isValidObject(backfileIdentityUpload);
};
export var getHintText = (isSizeValid, isTypeValid) => {
  var hint = '';
  if (!isTypeValid) {
    hint = 'Only JPEG, PNG, or JPG files are allowed.';
  } else if (!isSizeValid) {
    hint = 'Upload a file smaller than 5 MB.';
  }
  return hint;
};